var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "relatorios-ouvidoria" } },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              { staticClass: "main-container" },
              [
                _c("card-dashboard", {
                  staticClass: "custom-card",
                  attrs: {
                    title: "Total de conversas",
                    content: _vm.somaTotalDeConversas,
                    icon: "far fa-comments",
                    color: "#00537e"
                  }
                }),
                _c("card-dashboard", {
                  staticClass: "custom-card",
                  attrs: {
                    title: "Encerradas",
                    content: _vm.finalizadas,
                    icon: "far fa-calendar-check",
                    color: "blue"
                  }
                }),
                _c("card-dashboard", {
                  staticClass: "custom-card",
                  attrs: {
                    title: "Respondidas",
                    content: _vm.respondidas,
                    icon: "far fa-comment-check",
                    color: "green"
                  }
                }),
                _c("card-dashboard", {
                  staticClass: "custom-card",
                  attrs: {
                    title: "Aguardando resposta",
                    content: _vm.aguardandoResposta,
                    icon: "far fa-alarm-exclamation",
                    color: "yellow"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("p", { staticClass: "bolder" }, [_vm._v("Gráficos")]),
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab"
              }
            },
            _vm._l(_vm.tabConversas, function(item) {
              return _c(
                "el-tab-pane",
                {
                  key: item.name,
                  attrs: { label: item.label, name: item.name }
                },
                [
                  _vm.activeTab === item.name
                    ? _c(item.component, { tag: "component" })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fa0e81f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fa0e81f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/RelatoriosOuvidoria.vue
// module id = null
// module chunks = 